/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');
var utilsCommon = require('./utils');
var utilsClient = require('./utils-client');

var utils = _.extend(utilsCommon(), utilsClient());

var helpers = {};
_.extend(
    helpers,
    require('./client/all')(helpers, utils),

    utils.wrapHelpers(require('./common/url')(helpers, utils)),
    utils.wrapHelpers(require('./common/linkify')(helpers, utils)),
    utils.wrapHelpers(require('./common/string')(helpers, utils)),
    utils.wrapHelpers(require('./common/comparison')(helpers, utils)),
    utils.wrapHelpers(require('./common/array')(helpers, utils)),
);

module.exports = helpers;
